import nodeApiService from "../../../../services/nodeApiService"

export const callArtworksApi = (params, gallery, collection) =>
  nodeApiService.galleryArtworksByCollection(gallery.id, collection, params)
